// extracted by mini-css-extract-plugin
export default {"AvatarStack":"user-group-module__AvatarStack--MXFQo"};